<template>
    <p v-for="(p, i) of templateTextArray('dboptions.options.overview', { schemeName: scheme.name })" :key="i">{{ p }}</p>

    <SummaryRadioGroup v-model="selectedSchemeOption" :options="availableOptionsStatic">
        <template #extraContent="{ selected }">
            <BrightcoveVideoModal v-if="selectedSchemeOption === FinalSalaryOption.PensionIncreaseExchange"
                accountId="1509269527"
                videoId="6374435448112"
                linkText="See how Pension Increase Exchange works in this video."
                linkAriaLabel="Open modal to watch video on Pension Increase Exchange"
                modalVideoAriaLabel="You can watch this video to find out more about Pension Increase Exchange"
                modalTitle="Pension Increase Exchange" />

            <div v-if="selectedSchemeOption === FinalSalaryOption.PensionIncreaseExchange" class="pt-3">
                <Help title="Pension Increase Exchange" :text="htmlArray('dboptions.options.pie.read-more.body')" linkText="Read more about the PIE option."></Help>
            </div>
        </template>
    </SummaryRadioGroup>

    <div class="row mt-4">
        <div v-if="selectedSchemeOption === FinalSalaryOption.SchemeDefault">
            <DBOptionsLumpSumChoices :taxFreeCashOption="{ lumpSum: formatter.formatCurrency(taxFreeCashMax), annualIncome: formatter.formatCurrency(taxFreeCashAnnualIncome) }"
                                     :noTaxFreeCashOption="{ lumpSum: '£0', annualIncome: formatter.formatCurrency(noTaxFreeCashAnnualIncome) }" />
        </div>
        <div v-else-if="selectedSchemeOption === FinalSalaryOption.PensionIncreaseExchange">
            <DBOptionsLumpSumChoices :taxFreeCashOption="{ lumpSum: formatter.formatCurrency(taxFreeCashMax), annualIncome: formatter.formatCurrency(taxFreeCashAnnualIncome) }"
                                     :noTaxFreeCashOption="{ lumpSum: '£0', annualIncome: formatter.formatCurrency(noTaxFreeCashAnnualIncome) }" />
        </div>
        <div v-else-if="selectedSchemeOption === FinalSalaryOption.BridgingPension">
            <DBOptionsLumpSumChoices :taxFreeCashOption="{ lumpSum: formatter.formatCurrency(taxFreeCashMax), annualIncome: formatter.formatCurrency(taxFreeCashAnnualIncome) }"
                                     :noTaxFreeCashOption="{ lumpSum: '£0', annualIncome: formatter.formatCurrency(noTaxFreeCashAnnualIncome) }" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { formatter } from "../../../shared/ts/formatter";
import FinalSalaryOption from "@/guiide/ts/assets/finalsalary/finalSalaryOption";
import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
import SummaryRadioGroup from "../common/SummaryRadioGroup.vue";
import DBOptionsLumpSumChoices from "./DBOptionsLumpSumChoices.vue";
import BrightcoveVideoModal from "@/guiide/components/common/BrightcoveVideoModal.vue";
import { FinalSalaryOptionInfoStatic } from "@/guiide/ts/assets/finalsalary/finalSalaryOptionInfoStatic";
import FinalSalarySchemeOptionsDetail from "@/guiide/ts/response/finalSalarySchemeOptionsDetail";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";
import Help from "../common/Help.vue";

const props = defineProps({
    scheme: { type: Object as () => FinalSalaryScheme, required: true },
    optionsDynamic: { type: Object as () => FinalSalarySchemeOptionsDetail[], required: true },
    availableOptionsStatic: { type: Object as () => FinalSalaryOptionInfoStatic[], required: true }
});

const { templateTextArray, htmlArray } = useUIContent();

const taxFreeCashMax = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.maxTaxFreeCash ?? 0);
const taxFreeCashAnnualIncome = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.taxFreeCashAnnualIncome ?? 0);
const noTaxFreeCashAnnualIncome = ref(props.optionsDynamic.find(fsoi => fsoi.type == FinalSalaryOption.SchemeDefault)?.noTaxFreeCashAnnualIncome ?? 0);

const selectedSchemeOption = ref<FinalSalaryOption>(FinalSalaryOption.SchemeDefault);

watch(
    () => selectedSchemeOption.value,
    (newValue: FinalSalaryOption) => {
        const option = props.optionsDynamic.find(fsoi => fsoi.type == newValue);
        taxFreeCashMax.value = option.maxTaxFreeCash;
        taxFreeCashAnnualIncome.value = option.taxFreeCashAnnualIncome;
        noTaxFreeCashAnnualIncome.value = option.noTaxFreeCashAnnualIncome;
    }
);
</script>
